import React, { useEffect, useState } from "react";
import axios from "axios";
import { Plus, Minus } from "lucide-react";
import { faqs as defaultFaqs } from "../mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FAQ = () => {
  const [open, setOpen] = useState(0);
  const [faqs, setFaqs] = useState(defaultFaqs);

  useEffect(() => {
    axios.get(`${API}/content`).then((r) => {
      const remote = r.data?.faqs;
      if (Array.isArray(remote) && remote.length > 0) setFaqs(remote);
    }).catch(() => {});
  }, []);

  return (
    <section className="relative py-28 md:py-36 cosmic-panel overflow-hidden">
      <div className="stars opacity-70" />
      <div className="relative max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="divider-star justify-center"><span>The Quiet Questions</span></div>
          <h2 className="font-serif text-4xl md:text-6xl leading-[1.05] mt-8 text-[#EDE3D0]">
            Everything you were
            <span className="italic text-[#D4A85B]"> nervous to ask.</span>
          </h2>
        </div>

        <div className="divide-y divide-[#D4A85B]/15 border-y border-[#D4A85B]/15">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <button
                key={f.q}
                onClick={() => setOpen(isOpen ? -1 : i)}
                className="w-full text-left py-6 flex items-start gap-6 group"
              >
                <div className="pt-1 text-[#D4A85B]">
                  {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                </div>
                <div className="flex-1">
                  <div className="font-serif text-xl md:text-2xl text-[#EDE3D0]">{f.q}</div>
                  <div
                    className={`grid transition-[grid-template-rows] duration-500 ${
                      isOpen ? "grid-rows-[1fr] mt-3" : "grid-rows-[0fr]"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="text-[#EDE3D0]/75 leading-relaxed">{f.a}</p>
                    </div>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
